import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/services/golden-visa/GoldenVisaClient.jsx");
